module.exports = "/assets/83b110f4dc2e92eaaeeec1781a5ddbc2.svg";